import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { ImageContainer } from "../../constants/ImagesConstants";
import LanguageSwitcher from "./LanguageSwitcher";

const CommanHeader = () => {
  return (
    <>

      <header>
        <nav className="navbar navbar-expand-lg bg-color-p inner-header">
          <div className="container-fluid">
            
            <Link className="navbar-brand" to="/"><img src={ImageContainer?.TopLogoImage} /></Link>
            <div className='rightbtn d-flex align-items-center'>
              <LanguageSwitcher className="me-2" variant="light" />
              <Link className='btn btnwhiteOutline me-2' to={'/login'}>
                <FormattedMessage id="login" /></Link>
              <Link className='btn btnwhite' to={'/register'}>
                <FormattedMessage id="sign_up" /></Link>

            </div>
          </div>
        </nav>
      </header>
    </>
  )
}

export default CommanHeader;
